export default {
   login: 'تسجيل دخول',
   email: 'البريد الإلكتروني',
   password: 'كلمة المرور',
   new_password: 'كلمة المرور الجديدة',
   confirm_password: 'تأكيد كلمة المرور',
   incorrect_username_or_password: 'البريد الإلكتروني أو كلمة المرور غير صحبحة',
   loading: '... جاري التحميل',
   required: 'مطلوب *',
   requests: 'الطلبات',
   request: 'طلب',
   all_requests: 'جميع الطلبات',
   new_request: 'طلب جديد',
   request_status: 'حالة الطلب',
   inprogress: 'تحت المعالجة',
   approved: 'تمت الموافقه',
   approvment: 'الموافقة',
   rejected: 'رفض',
   canceled: 'الغي',
   completed: 'مكتمل',
   home: 'الرئيسية',
   setting: 'الإعدادات',
   search: 'بحث',
   my_tasks: 'مهامي',
   my_history: 'تاريخ الطلبات',
   complete: 'مكتمل',
   form_builder: 'Form Builder',
   staff: 'الموظفين',
   requester_name: 'اسم الموظف',
   form_name: 'Form Name',
   priority: 'الأولوية',
   step: 'المرحلة',
   date: 'التاريخ',
   due_date: 'الموعد المحدد',
   date_and_time: 'تاريخ ووقت أخر تحديث',
   preivew: 'معاينة',
   add_message: 'أضف رسالة',
   redirect_ticket: 'إعادة توجيه الطلب',
   approve: 'قبول',
   decline: 'رفض',
   redirect: ' إعادة توجيه',
   save: 'حفظ',
   done: 'تم',
   delete: 'حذف',
   cancel: 'إلغاء',
   back: 'عودة',
   clear: 'مسح',
   reason_or_message: 'السبب / الرسالة',
   no_approves_yet: 'No Approves yet',
   approved_by: 'تمت الموافقه من قبل',
   created_by: 'تم الطلب من قبل',
   getway: 'Gateway',
   message: 'رسالة',
   attatchments: 'مرفقات',
   approved_requests: 'الطلبات الموافق عليها',
   completed_requests: 'الطلبات المكتملة',
   rejected_requests: 'الطلبات المرفوضة',
   id: 'ID',
   name: 'الإسم',
   full_name: 'الإسم بالكامل',
   staff_number: 'رقم الموظف',
   department: 'القسم',
   role: 'المنصب',
   manager: 'المدير',
   supervisor_in_order: 'المشرفين (بالترتيب)',
   permissons: 'الصلاحيات',
   can_take_action: 'Can Take Action',
   can_generate_form: 'Can Generate Form',
   can_add_staff: 'Can Add Staff',
   can_set_priority: 'Can Set a Priority to the Request',
   can_redirect_request: 'Can Redirect The Request',
   can_see_all_tickets: 'Can See All Tickets',
   can_complete_request: 'Can Complete Request',
   staff_list: 'قائمة الموظفين',
   add_new_staff: 'إضافة موظف جديد',
   edit_staff: 'تعديل موظف',
   forms_list: 'قائمة النماذج',
   build_a_new_form: 'build a new form',
   form_general_info: 'Form General Info',
   form_preview: 'معاينة النموذج',
   form_gatway: 'Form Gateway',
   reminder_days: 'موعد التذكير',
   file_attachments: 'الملفات المرفقة',
   no_file_attachments: 'عدم السماح بإرفاق الملفات',
   allow_only_one_file_attachments: 'السماح بإرفاق ملف واحد فقط',
   allow_multiple_attachments: 'السماح بإرفاق العديد من الملفات',
   please_select_a_staff: 'الرجاء إختيار موظف',
   select_the_staff_in_order: 'إختر موظف (بالترتيب)',
   staff_manager: 'مدير الموظف',
   staff_supervisors: 'مشرفي الموظف',
   select_the_staff: 'إختر موظف',
   select_a_request: 'اختر الطلب',
   add_the_form: 'Add the Form',
   confirm_discard_changes: 'تأكيد عدم حفظ التغييرات',
   are_you_sure_you_want_to_do_this_action: 'هل أنت متأكد أنك تريد القيام بهذا الإجراء؟',
   cannot_delete_this_form_bcz_it_has_an_open_tickets: "Can't delete this form because it has an open tickets",
   are_you_sure_you_want_to_discard_all_changes: 'هل أنت متأكد من عدم حفظ التغييرات',
   are_you_sure_you_need_to_add_this_form: 'Are you sure you need to add this form?',
   yes_add_it: 'نعم ، أضف',
   yes_delete_it: 'نعم، احذف',
   yes_discard_changes: 'نعم ، عدم الحفظ',
   please_set_the_form_name: 'Please set the form name',
   please_set_the_reminder_days: 'الرجاء إضافة أيام التذكير',
   please_select_the_file_attachments_type: 'فضلاً اختر نوع الملف المرفق',
   please_complete_the_form: 'الرجاء إكمال تعبئة حقول النموذج',
   please_confirm_the_password: 'الرجاء تأكيد كلمة المرور',
   password_not_match: 'كلمة المرور غير متطابقة',
   request_was_send: 'تم إرسال الطلب بنجاح',
   request_was_canceled: 'تم إلغاء الطلب بنجاح',
   form_was_added: 'تم إضافة النموذج بنجاح',
   form_info_was_updated: 'تم تحديث بيانات النموذج بنجاح',
   form_was_deleted: 'تم حذف النموذج بنجاح',
   staff_was_added: 'تم إضافة الموظف بنجاح',
   staff_was_updated: 'تم تعديل بيانات الموظف بنجاح',
   request_was_approved: 'تمت موافقة الطلب بنجاح',
   request_was_declined: 'تم رفض الطلب',
   request_was_completed: 'تم إنهاء الطلب',
   request_was_redirected: 'تم إعادة توجيه الطلب',
   your_data_was_updated_successfully: 'تم تعديل البيانات بنجاح',
   something_wrong: 'حدث خطأ ما!',
   normal: 'عادي',
   urgent: 'طارئ',
   top_urgent: 'طارئ جدا',
   state: 'الحالة',
   select_date_to_export: 'إختر تاريخ',
   please_select_date: 'الرجاء إختيار تاريخ',
   invalid_date_range: 'الفترة الزمنية غير صالحة',
   from_date: 'من تاريخ',
   to_date: 'الى تاريخ',
   export: 'تنزيل',
   selected_duration: 'الفترة الزمنية المختارة',
   print: 'طباعة',
   directed_to: "مُعاد توجيهها إلى",
   directed_by: "مٌعاد توجيهها من قبل",
   ticket_number: "رقم الطلب",
   opened_at: "تاريخ الارسال",
   closed_at: "تاريخ الإغلاق",
   forgetPass: "نسيت كلمة المرور",
   resetPassword: "إعادة تعيين كلمة المرور",
   forget_your_password: "نسيت كلمة المرور؟",
   invalid_email: "البريد الالكتروني غير صالح",
   forget_pass_txt: "لرجاء إدخال بريدك الإلكتروني أدناه وسنرسل لك معلومات لاستعادة حسابك",
   add: "إضافة",
   add_file_attachment: "إضافة ملف مرفق",
   add_answer_form: "إضافة نموذج إجابة",
   the_forms: "النماذج",
   the_answer_form: "نموذج الإجابة",
   remove_the_answer_form: "إزالة نموذج الإجابة",
   show_the_answer_form: "عرض نموذج الإجابة",
   approve_this_request: "أوافق على هذا الطلب",
   open_tickets: "كل الطلبات المفتوحة",
   closed_tickets: "الطلبات المغلقة",
   all_tickets: "كل الطلبات",
   re_request: "إعادة الطلب",
   answer_form: "نموذج إجابة",
   loading_more: "المزيد",
   open_at: 'تاريخ الانشاء',
   search_by_ticket_number: "بحث برقم الطلب",

}